exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4{padding-top:6px;padding-bottom:0}h4,h6{color:#000}h6{padding-top:4px;margin-bottom:4px}strong{padding-top:3px}.table-grid{width:100%;border-collapse:collapse}.table-grid>tbody>tr>th{padding:0}.table-grid>tbody>tr>td,.table-grid>tbody>tr>th,.table-grid>tfoot>tr>td,.table-grid>tfoot>tr>th,.table-grid>thead>tr>td,.table-grid>thead>tr>th{border:1px solid #000}.table-grid .table-grid td,.table-grid .table-grid th{border-top:0;border-right:1px solid #000;border-bottom:0;border-left:0}.table-grid .table-grid td:last-child,.table-grid .table-grid th:last-child{border-right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4397e28e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DC/instructorWorkLoad.vue
// module id = 412
// module chunks = 0